import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Droppable } from "react-beautiful-dnd";
import EGCard from './Card';
import { findSg } from '../utils';

const GeoRegionList = () => {
    const geoRegionList = useSelector((state) => state.scoutKanban.geoRegionList);
    const isRequestingGeoRegion = useSelector((state) => state.scoutKanban.isRequestingGeoRegion);
    const scoutSearchText = useSelector((state) => state.scoutKanban.scoutSearchText);

    const geoRegionShapesList = useMemo(() => {
        let shapesList = [];
        if (geoRegionList && geoRegionList.length > 0) {

            geoRegionList.filter(region => region.status_id === 1 && region.geo_region_type_id === 2
            ).forEach((region) => {
                region.shapes.map((shape) => {
                    return shapesList.push(shape);
                })
            })
        }
        return shapesList;
    }, [geoRegionList])
    return (
        <div className='scout_drag_container'>
            <div className="scout_kanban_header w-100"><i className="icon icon-map-shape mr-2"></i> Fields</div>
            <Droppable droppableId="geoRegion"/*  isDropDisabled={!isToday(range)} */>
                {(provided, snapshot) => (
                    <div
                        ref={provided.innerRef}
                        className={`kanban-column-body scout-cards ${snapshot.isDraggingOver ? "dragging-over" : ""}`}
                    >
                        {isRequestingGeoRegion && <div className="mt-4 w-100 text-center">Loading...</div>}
                        {geoRegionShapesList && geoRegionShapesList.length > 0 &&
                            geoRegionShapesList.map((shape, shapeIndex) => {
                                return (
                                    <EGCard
                                        key={`shapeId_${shape.geo_shape_uuid}`}
                                        index={shapeIndex}
                                        shapeId={shape.geo_shape_uuid}
                                        shape={shape}
                                        onFilter={e => findSg(e, { searchText: scoutSearchText }, 'field')}
                                    />
                                )
                            })
                        }
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </div>
    )

}

export default GeoRegionList